/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from '../../../../../__generated__/zeus/types';

import type { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
/** Arguments for opting a phone number into a one-time SMS when a marketplace listing becomes available. */
export type BuyerListingNotificationOptInInput = {
  /** Address UUID of the listing to be notified about. */
  addressId: Types.Scalars['UUID']['input'];
  /** Version key of the SMS consent disclosure shown to the viewer, recorded for the legal audit trail. */
  consentLanguage: Types.Scalars['String']['input'];
  /** Direct US number to text when the listing becomes available, without an extension, up to 50 characters. US national format or +1-prefixed; supplied numbers are normalized to E.164. */
  phoneNumber: Types.Scalars['PhoneNumber']['input'];
};

export type BuyerListingNotificationOptInMutationVariables = Exact<{
  input: Types.BuyerListingNotificationOptInInput;
}>;


export type BuyerListingNotificationOptInMutation = { buyerListingNotificationOptIn:
    | { __typename: 'CommandResult', success: Types.Scalars['Boolean']['output'] }
    | { __typename: 'InvalidInputError' }
    | { __typename: 'NotFoundError' }
    | { __typename: 'UnauthorizedError' }
   };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const BuyerListingNotificationOptInDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation BuyerListingNotificationOptIn($input: BuyerListingNotificationOptInInput!) {
  buyerListingNotificationOptIn(input: $input) {
    __typename
    ... on CommandResult {
      success
    }
  }
}
    `) as unknown as TypedDocumentString<BuyerListingNotificationOptInMutation, BuyerListingNotificationOptInMutationVariables>;